import { AdacHeadline, AdacText } from '@adac-de/component-library';
import { clsx } from 'clsx';
import React from 'react';
import styles from './confirmation-box.module.scss';
import { CenteredText } from '@components/text/centered-text';
import { Icon } from '@components/icons/icons';

const SuccessBoxContent: React.FC<Omit<SolarApimPartnerList, '__typename' | 'success'>> = ({
  leadId,
  partners
}) => (
  <>
    <div className={styles.yellowCircleBackground}>
      <Icon.Check fill="black90" />
    </div>
    <AdacHeadline tagName="h2" styleAs="h3slab" className="margin-top--l margin-bottom--s" center>
      Vielen Dank!
    </AdacHeadline>
    <CenteredText>Wir haben Ihre Anfrage erhalten und weitergeleitet:</CenteredText>

    <div className={styles.partnerList}>
      {partners.map(partner => (
        <div className={styles.partnerListItem} key={partner.partnerName}>
          {partner.success ? (
            <Icon.Check fill="success" width={30} height={30} />
          ) : (
            <Icon.Close fill="error" className={styles.errorIcon} width={18} height={18} />
          )}
          <AdacText type="medium" key={partner.partnerName}>
            {partner.partnerName} -{' '}
            {partner.success
              ? 'Erfolgreich kontaktiert, unser Solar-Partner meldet sich schnellstmöglich bei Ihnen.'
              : 'Entschuldigung, es gab einen Übermittlungsfehler, bitte senden Sie diese Anfrage erneut.'}
          </AdacText>
        </div>
      ))}
    </div>

    {leadId && (
      <>
        <CenteredText className="margin-bottom--xs">
          Ihre persönliche Bearbeitungsnummer lautet:{' '}
          <AdacText type="medium" bold tagName="span" className={styles.leadId}>
            {leadId}
          </AdacText>
        </CenteredText>
        <CenteredText>Bitte notieren Sie diese für eventuelle Rückfragen.</CenteredText>
      </>
    )}
  </>
);

const ErrorBoxContent: React.FC = () => (
  <>
    <div className={styles.yellowCircleBackground}>
      <Icon.Exclamationmark width={42} height={42} fill="black90" />
    </div>
    <AdacHeadline tagName="h2" styleAs="h3slab" className="margin-top--l margin-bottom--s" center>
      Entschuldigung.
    </AdacHeadline>
    <CenteredText>
      Bei der Übermittlung Ihrer Daten ist ein Fehler aufgetreten. Bitte versuchen Sie es zu einem
      späteren Zeitpunkt erneut.
    </CenteredText>
  </>
);

export const ConfirmationBox: React.FC<{ requestResponse: SolarApimPartnerList }> = ({
  requestResponse
}) => (
  <div className={clsx(styles.confirmationBox, 'margin-bottom--l')}>
    {requestResponse?.success ? (
      <SuccessBoxContent leadId={requestResponse.leadId} partners={requestResponse.partners} />
    ) : (
      <ErrorBoxContent />
    )}
  </div>
);
